import { registryApi } from '../clients/AxiosClients'
import i18n from '../../VueI18n'

/**
 * Retorna todas as cubagens cadastradas no banco de dados
 */
const getAllCubagens = async () => {
	return registryApi.get('v1/Cubagem')
}

/**
 * Retorna todas as cubagens estruturadas para o componente de DropdownFk
 */
const getCubagemDropdown = async () => {
	const {
		data: { result },
	} = await registryApi.get('v1/Cubagem/GetDropdown')
	return result.map((cubagem) => {
		return {
			id: cubagem.id,
			[i18n.t('code')]: `CB-${cubagem.cbgm_cd_codigo}`,
			[i18n.t('description')]: cubagem.cbgm_ds_descricao,
			[i18n.t('farm')]: cubagem.fzda_nm_nome
				? `FA-${cubagem.fzda_cd_codigo} - ${cubagem.fzda_nm_nome}`
				: '-',
			'Ordem de Serviço': cubagem.orsv_ds_descricao
				? `OS-${cubagem.orsv_cd_codigo} - ${cubagem.orsv_ds_descricao}`
				: '-',
			'Estrato Florestal': cubagem.esfl_ds_descricao
				? `EF-${cubagem.esfl_cd_codigo} - ${cubagem.esfl_ds_descricao}`
				: '-',
		}
	})
}

/**
 * Cadastrar nova cubagem no banco de dados
 * @param {Object} body Cubagem que será cadastrada
 */
const createCubagem = async (body) => {
	return registryApi.post('v1/Cubagem', body)
}

/**
 * Atualiza Cubagem no banco de dados
 * @param {Object} body Cubagem que será atualizada
 */
const updateCubagem = async (body) => {
	return registryApi.put('v1/Cubagem', body)
}

/**
 * Lista dos ids de Cubagens que devem ser excluidos do banco de dados
 * nome do parametro deve ser data pois método DELETE do axios obrigatoriamente recebe um argumento 'data'
 * @param {Array} data Lista dos ids de Cubagem
 */
const deleteCubagemByIdList = async (data) => {
	return registryApi.delete('v1/Cubagem/DeleteByIdList', { data })
}

export const importarCSVCubagem = (data) => {
	return registryApi.post('v1/Cubagem/ImportarCSVCubagem', data)
}

export const buscaCubagemParaExportacao = (cubagemId) => {
	return registryApi.get(`v1/Cubagem/BuscarCubagemParaExportacao?cubagemId=${cubagemId}`)
}

export { getAllCubagens, getCubagemDropdown, createCubagem, updateCubagem, deleteCubagemByIdList }
